// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"7bf622e528ac9caa20a2","883":"635d43e0ed69c9c048e3"}[chunkId] + ".js";
};